const entries = [
  { name: "吃瓜17 主站首页", tag: "主站", tone: "bg-primary-100 text-primary-700", status: "稳定运行", dot: "bg-primary-500", note: "最新吃瓜17网址地址，日常浏览优先从这里进入。" },
  { name: "吃瓜17 备用通道 A", tag: "备用", tone: "bg-accent-100 text-accent-800", status: "正常可用", dot: "bg-accent-500", note: "主站波动时的镜像备用链接，可随时切换使用。" },
  { name: "吃瓜17 备用通道 B", tag: "备用", tone: "bg-accent-100 text-accent-800", status: "维护中", dot: "bg-secondary-400", note: "临时维护，预计稍后恢复，请优先走主站或备用 A。" },
  { name: "吃瓜17 手机访问页", tag: "移动", tone: "bg-secondary-200 text-secondary-800", status: "建议收藏", dot: "bg-secondary-500", note: "移动端优化入口，扫码或收藏后直接在手机浏览器打开。" },
  { name: "吃瓜17 资源更新页", tag: "看点", tone: "bg-secondary-200 text-secondary-800", status: "持续更新", dot: "bg-secondary-500", note: "聚焦近期热议看点与频道内容更新的汇总直达页。" },
  { name: "吃瓜17 历史收藏夹", tag: "工具", tone: "bg-secondary-200 text-secondary-800", status: "供你归档", dot: "bg-secondary-500", note: "便于把常用网址、备用地址统一归档，避免链接丢失。" },
];

export default function EntryGrid() {
  return (
    <section id="entries" className="bg-secondary-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-widest text-primary-600">· 官方入口汇总</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">
            吃瓜17 网址地址，一处收录
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            下面是整理好的吃瓜17导航入口列表。每条标注运行状态，复制地址或直接点进入即可，
            收藏后可长期复用同一份链接清单。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-2 gap-4">
          {entries.map((e) => (
            <article
              key={e.name}
              className="flex flex-col sm:flex-row sm:items-center gap-4 rounded-xl border border-secondary-200/70 bg-background-50 p-5"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="grid place-items-center w-11 h-11 shrink-0 rounded-lg bg-secondary-100 text-secondary-700">
                  <i className="ri-global-line text-xl" />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm md:text-base font-bold text-foreground-950 whitespace-nowrap">{e.name}</h3>
                    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${e.tone}`}>
                      {e.tag}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{e.note}</p>
                  <span className="mt-1.5 inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <span className={`w-1.5 h-1.5 rounded-full ${e.dot}`} />
                    状态：{e.status}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-2 shrink-0">
                <button
                  type="button"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-xs font-medium border border-secondary-300 bg-background-50 text-foreground-700 hover:bg-secondary-100 transition-colors"
                >
                  <i className="ri-link text-sm" />
                  复制地址
                </button>
                <button
                  type="button"
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2 text-xs font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 transition-colors"
                >
                  进入
                  <i className="ri-arrow-right-s-line text-base" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}